import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog'
import { take } from 'rxjs/operators'
import { ComponentType } from '@angular/cdk/portal'
import {
  AddInvoiceDialogComponent,
  CreateInvoiceParams,
} from '@tv3/containers/invoices/invoices/add-invoice/add-invoice-dialog.component'

@Injectable()
export class AddInvoiceDialogService {
  constructor(private dialog: MatDialog) {}

  public open<T>(component: ComponentType<T>, data: CreateInvoiceParams): MatDialogRef<T> {
    const defaultConfig: MatDialogConfig = {
      width: '100%',
      height: '100%',
      maxWidth: 'auto',
      backdropClass: '',
      position: {
        right: '0px',
        bottom: '0px',
      },
      data: { ...data },
      panelClass: ['modal', 'side-modal-lg', 'modal-inquiry-details', 'right'],
    }

    const dialogRef = this.dialog.open(component, defaultConfig)

    if (dialogRef['_overlayRef'].overlayElement) {
      dialogRef['_overlayRef'].overlayElement.parentElement.className += ' dialog-wrapper'
    }

    dialogRef
      .beforeClosed()
      .pipe(take(1))
      .subscribe(() => {
        dialogRef['_containerInstance']['_elementRef'].nativeElement.classList.add('side-closing')
      })

    return dialogRef
  }

  public openSide(params: CreateInvoiceParams) {
    return this.open(AddInvoiceDialogComponent, params)
  }
}
